import { IInvoicingItem } from './IInvoicingItem';

export type TInvoicingAttemptStatus =
  | 'pending'
  | 'issuing'
  | 'verifying'
  | 'succeeded'
  | 'failed'
  | 'needs_review';

/** Shape returned by GET /invoicing/attempts/:publicId */
export interface IInvoicingAttemptState {
  publicId: string;
  status: TInvoicingAttemptStatus;
  orderIds: number[];
  invoicingItem: IInvoicingItem | null;
  errorCode: string | null;
  errorMessage: string | null;
}

/** 202 body returned when an invoice attempt is parked as processing. */
export interface IInvoiceProcessingResponse {
  status: 'processing';
  attemptPublicId: string;
  pollAfterMs: number;
}

/** WS payload of the `r:{rid}:invoicingAttempt` event. */
export interface IInvoicingAttemptWsPayload {
  publicId: string;
  status: TInvoicingAttemptStatus;
  orderIds: number[];
  invoicingItemId: number | null;
  errorCode: string | null;
  errorMessage: string | null;
}

export type TInvoiceIssueResponse = IInvoicingItem | IInvoiceProcessingResponse;

export function isInvoiceProcessingResponse(
  data: TInvoiceIssueResponse
): data is IInvoiceProcessingResponse {
  return (data as IInvoiceProcessingResponse).status === 'processing';
}
